import i18n from '@/i18n/index';
import RequirementPromotionalText from './RequirementPromotionalText';
const { t } = i18n;

export const enum SubmitStatusEnum {
  KickOff = 'KickOff',
  Address = 'Address',
  AccountInfo = 'accountInfo', // 待达人填写会员信息
  script = 'script',
  video = 'video',
  finalLink = 'finalLink',
  address = 'address',
  receivePayment = 'receivePayment'
}

export const submitTextMap: any = {
  [SubmitStatusEnum.Address]: t('config.submit.address', {
    defaultValue: 'Complete redemption info'
  }),
  [SubmitStatusEnum.AccountInfo]: t('config.submit.account', {
    defaultValue: 'Submit account details'
  }),
  [SubmitStatusEnum.script]: t('config.submit.scriptTitle', {
    defaultValue: 'Submit idea/script'
  }),
  [SubmitStatusEnum.video]: t('config.submit.video', {
    defaultValue: 'Submit content'
  }),
  [SubmitStatusEnum.finalLink]: t('config.submit.finalLink', {
    defaultValue: 'Submit final link'
  })
};

export enum OrderContentItemStage {
  KickOff = 'KickOff',
  Address = 'Address',
  AccountInfo = 'AccountInfo',
  Script = 'Script',
  Draft_1 = 'Draft_1',
  Draft_2 = 'Draft_2',
  Draft_3 = 'Draft_3',
  Draft_4 = 'Draft_4',
  Draft_5 = 'Draft_5',
  Final = 'Final'
}

export const OrderContentItemStageText: any = {
  [OrderContentItemStage.KickOff]: t('config.submit.kickoffProduction', {
    defaultValue: 'Kickoff production'
  }),
  [OrderContentItemStage.Address]: t('config.submit.address', {
    defaultValue: 'Complete redemption info'
  }),
  [OrderContentItemStage.AccountInfo]: t('config.submit.account', {
    defaultValue: 'Submit account details'
  }),
  [OrderContentItemStage.Script]: t('config.submit.scriptTitle', {
    defaultValue: 'Submit idea/script'
  }),
  [OrderContentItemStage.Draft_1]: t('config.submit.submitDraft', {
    defaultValue: 'Submit draft'
  }),
  [OrderContentItemStage.Draft_2]: t('config.submit.submitDraft', {
    defaultValue: 'Submit draft'
  }),
  [OrderContentItemStage.Draft_3]: t('config.submit.submitDraft', {
    defaultValue: 'Submit draft'
  }),
  [OrderContentItemStage.Draft_4]: t('config.submit.submitDraft', {
    defaultValue: 'Submit draft'
  }),
  [OrderContentItemStage.Draft_5]: t('config.submit.submitDraft', {
    defaultValue: 'Submit draft'
  }),
  [OrderContentItemStage.Final]: t('config.submit.finalLink', {
    defaultValue: 'Submit final link'
  })
};

export const submitModalDescDefault: any = {
  [SubmitStatusEnum.script]: t('config.submitModalDesc.script', {
    defaultValue:
      'Please ensure your link (e.g., Google Drive) is public so reviewers can access it. Wait for brand approval before publishing your content.'
  }),
  [SubmitStatusEnum.video]: t('config.submitModalDesc.video', {
    defaultValue:
      'Please ensure your link (e.g., Google Drive) is public so reviewers can access it. Wait for brand approval before publishing your content.'
  }),
  [SubmitStatusEnum.finalLink]: t('config.submitModalDesc.finalLink', {
    defaultValue:
      "Please make sure you're uploading your approved final draft. To obtain your link, open your video on Platform > Copy the link in the URL bar."
  })
};

export const submitModalDescYoutube: any = {
  [SubmitStatusEnum.script]: t('config.submitModalDescYoutube.script', {
    defaultValue:
      'Please ensure your link (e.g., Google Drive) is public so reviewers can access it. Wait for brand approval before publishing your content.'
  }),
  [SubmitStatusEnum.video]: t('config.submitModalDescYoutube.video', {
    defaultValue:
      'Please ensure the link is an unlisted YouTube video. (e.g. https://www.youtube.com/watch?v=3lnpTnjcH-k)'
  }),
  [SubmitStatusEnum.finalLink]: t('config.submitModalDescYoutube.finalLink', {
    defaultValue:
      'Please make sure your video has been <b>set to public (not "unlisted")</b>'
  })
};

export const submitModalDescTiktok: any = {
  [SubmitStatusEnum.script]: t('config.submitModalDescTiktok.script', {
    defaultValue:
      'Please ensure your link (e.g., Google Drive) is public so reviewers can access it. Wait for brand approval before publishing your content.'
  }),
  [SubmitStatusEnum.video]: t('config.submitModalDescTiktok.video', {
    defaultValue:
      'Please ensure your link (e.g., Google Drive) is public so reviewers can access it. Wait for brand approval before publishing your content.'
  }),
  [SubmitStatusEnum.finalLink]: t('config.submitModalDescTiktok.finalLink', {
    defaultValue:
      "Please make sure you're uploading your approved final draft. To obtain your link, open your video on Tiktok > Copy the link in the URL bar."
  })
};

export const submitModalDescInstagram: any = {
  [SubmitStatusEnum.script]: t('config.submitModalDescInstagram.script', {
    defaultValue:
      'Please ensure your link (e.g., Google Drive) is public so reviewers can access it. Wait for brand approval before publishing your content.'
  }),
  [SubmitStatusEnum.video]: t('config.submitModalDescInstagram.video', {
    defaultValue:
      'Please ensure your link (e.g., Google Drive) is public so reviewers can access it. Wait for brand approval before publishing your content.'
  }),
  [SubmitStatusEnum.finalLink]: t('config.submitModalDescInstagram.finalLink', {
    defaultValue:
      "Please make sure you're uploading your approved final draft. To obtain your link, open your video on Instagram > Copy the link in the URL bar."
  })
};

export const submitModalLinkTitle: any = {
  [SubmitStatusEnum.script]: t('config.submitModalLinkTitle.script', {
    defaultValue: 'Idea/script link'
  }),
  [SubmitStatusEnum.video]: t('config.submitModalLinkTitle.video', {
    defaultValue: 'Content draft link (Must be publicly accessible)'
  }),
  [SubmitStatusEnum.finalLink]: t('config.submitModalLinkTitle.finalLink', {
    defaultValue: 'Final link'
  })
};

// 0, 待提交 Draft
// 1, 等待审核
// 2, 等待发布
// 3, 已发布, 等待支付
// 4, 已支付
// 5 未知
export enum ProgressStatusEnum {
  SCRIPT = 0,
  DRAFT = 1,
  PUBLISH = 2,
  PAYMENT = 3,
  OTHER = 5 // 付款完成。
}

// post date enum
export enum PostTimeType {
  FLEXIBLE = 'flexible',
  FIXED = 'fixed'
}

export enum TabEnum {
  Delivery = 'Delivery',
  DealInfo = 'Deal info',
  Requirement = 'Requirement',
  AhaStudio = 'Aha studio'
}

export const DedicatedVideoContents: {
  title: string;
  content: any[];
  img?: string;
}[] = [
  {
    title: t('config.contentPermanenceRequirement.title', {
      defaultValue: 'Content permanence requirement'
    }),
    content: [
      t('config.contentPermanenceRequirement.content', {
        defaultValue:
          'The published content must remain permanently visible on your account. Content removal is not permitted under this collaboration agreement. This includes deleting, archiving, or making the post private.'
      })
    ],
    img: ''
  },
  {
    title: t('config.contentRestrictions.title', {
      defaultValue: 'Content restrictions'
    }),
    content: [
      t('config.contentRestrictions.content', {
        defaultValue:
          'We recommend avoiding political commentary, explicit sexual content, graphic violence, sensitive social issues, or misleading information in recent content, as these can negatively impact all brand collaborations.'
      })
    ],
    img: ''
  },
  {
    title: t('config.ideaSubmission.title', {
      defaultValue: 'Idea submission'
    }),
    content: [
      t('config.ideaSubmission.content', {
        defaultValue:
          "Please write a simple idea of how you plan to make your video. Once it's approved, you can start creating it. This helps avoid changes or rework if the video doesn't meet the requirements."
      })
    ]
  },
  {
    title: t('config.videoContent.title', { defaultValue: 'Video content' }),
    content: [
      t('config.videoContent.content', {
        defaultValue:
          'Once the application is approved, please check out the Aha studio as a reference before starting the video production process.'
      })
    ],
    img: '/head-studio.png'
  },
  {
    title: t('config.videoLength.title', { defaultValue: 'Video length' }),
    content: [
      t('config.videoLength.content', {
        defaultValue:
          'Ensure the overall video length is <b>at least 5 minutes</b>'
      })
    ],
    img: '/y-vl-five.png'
  },
  {
    title: t('config.cta.title', { defaultValue: 'CTA' }),
    content: [
      t('config.cta.content', {
        defaultValue:
          'Place the call-to-action at the most engaging point in the video, clearly stating something like, "Use the on-screen coupon code for exclusive offers" and "Check the link in the description for more details," while displaying the coupon code if available. You can choose the CTA wording that resonates best with your audience. Driving conversions impacts future collaboration rates.'
      })
    ],
    img: '/new_cta.png'
  },
  {
    title: t('config.descriptionAndVideoTitle.title', {
      defaultValue: 'Description & Video title'
    }),
    content: [
      t('config.descriptionAndVideoTitle.content1', {
        defaultValue:
          "Mention the brand name in the video title; if it's not suitable for the title, ensure it is included in the video description."
      }),
      {
        title: t('config.descriptionAndVideoTitle.content2.title', {
          defaultValue:
            '<b>Use a strong call-to-action for promotion at the beginning of description</b> and as the <b>first pinned comment.</b> '
        }),
        children: [
          t('config.descriptionAndVideoTitle.content2.children', {
            defaultValue:
              'Ensure CTA and link are visible even when collapsed. e.g. Try it now: {promotional link}'
          })
        ]
      },
      <RequirementPromotionalText />
    ],
    img: '/y-des-link.png'
  },
  {
    title: '',
    content: [
      t('config.noTagging.title', {
        defaultValue:
          "<b> Do not tag(@) the official brand's accounts unless specified .</b> This approach helps focus audience attention on the most crucial promotional links."
      }),
      t('config.noTagging.content', {
        defaultValue:
          'Except for the legally required sponsorship disclosure in the description or caption, do not include any additional language or indications (e.g., "#ad" or "advertisement") that explicitly label the content as an ad.'
      })
    ],
    img: '/y-des-tag.png'
  },
  {
    title: t('config.timestamp.title', { defaultValue: 'Timestamp' }),
    content: [
      t('config.timestamp.content', { defaultValue: 'Create your timestamps.' })
    ],
    img: '/y-timestamp.png'
  },
  {
    title: t('config.musicAndEffects.title', {
      defaultValue: 'Music and effects'
    }),
    content: [
      t('config.musicAndEffects.content', {
        defaultValue:
          'Check for copyright restrictions in your background music, sound effects, and clips.'
      })
    ],
    img: ''
  }
];

export const IntegratedVideoContents: {
  title: string;
  content: any[];
  img?: string;
}[] = [
  {
    title: t('config.integratedVideo.contentPermanence.title', {
      defaultValue: 'Content permanence requirement'
    }),
    content: [
      t('config.integratedVideo.contentPermanence.content', {
        defaultValue:
          'The published content must remain permanently visible on your account. Content removal is not permitted under this collaboration agreement. This includes deleting, archiving, or making the post private.'
      })
    ],
    img: ''
  },
  {
    title: t('config.integratedVideo.contentRestrictions.title', {
      defaultValue: 'Content restrictions'
    }),
    content: [
      t('config.integratedVideo.contentRestrictions.content', {
        defaultValue:
          'We recommend avoiding political commentary, explicit sexual content, graphic violence, sensitive social issues, or misleading information in recent content, as these can negatively impact all brand collaborations.'
      })
    ],
    img: ''
  },
  {
    title: t('config.integratedVideo.ideaSubmission.title', {
      defaultValue: 'Idea submission'
    }),
    content: [
      t('config.integratedVideo.ideaSubmission.content', {
        defaultValue:
          "Please write a simple idea of how you plan to make your video. Once it's approved, you can start creating it. This helps avoid changes or rework if the video doesn't meet the requirements."
      })
    ]
  },
  {
    title: t('config.integratedVideo.videoContent.title', {
      defaultValue: 'Video content'
    }),
    content: [
      t('config.integratedVideo.videoContent.content', {
        defaultValue:
          'Once the application is approved, please check out the Aha studio as a reference before starting the video production process.'
      })
    ],
    img: '/head-studio.png'
  },
  {
    title: '',
    content: [
      t('config.integratedVideo.callToAction.content', {
        defaultValue:
          'During the video, make sure to mention, "Click the link in the description for more details" and "don\'t forget to use the on-screen coupon code for special offers" while displaying the coupon code in the video.'
      })
    ]
  },
  {
    title: t('config.integratedVideo.videoLength.title', {
      defaultValue: 'Video length'
    }),
    content: [
      t('config.integratedVideo.videoLength.content1', {
        defaultValue:
          'The promotional segment should constitute at least 30% of the total video duration to ensure the message is effectively conveyed while maintaining a balanced viewing experience.'
      }),
      t('config.integratedVideo.videoLength.content2', {
        defaultValue:
          "The promotional content should be seamlessly integrated into the video in a way that feels organic, authentic, and aligned with the creator's usual style and tone. Avoid overly scripted or forced messaging to ensure the promotion resonates naturally with the audience."
      })
    ],
    img: '/60s.png'
  },
  {
    title: t('config.integratedVideo.placement.title', {
      defaultValue: 'Placement'
    }),
    content: [
      t('config.integratedVideo.placement.content', {
        defaultValue:
          "Ensure that the sponsored content about the product is presented<b> before reaching 50% of the video's total duration.</b>"
      })
    ],
    img: '/placement.png'
  },
  {
    title: t('config.integratedVideo.description.title', {
      defaultValue: 'Description'
    }),
    content: [
      {
        title: t('config.integratedVideo.description.content1.title', {
          defaultValue:
            '<b>Use a strong call-to-action</b> for promotion at the<b> beginning of description</b> and as the <b>first pinned comment.</b>'
        }),
        children: [
          t('config.integratedVideo.description.content1.child1', {
            defaultValue: 'Ensure CTA and link are visible even when collapsed.'
          }),
          t('config.integratedVideo.description.content1.child2', {
            defaultValue: 'E.g. Try it now: {promotional link}'
          })
        ]
      },
      <RequirementPromotionalText />
    ],
    img: '/y-des-link.png'
  },
  {
    title: '',
    content: [
      t('config.integratedVideo.description.content3', {
        defaultValue:
          "<b>Do not tag(@) the official brand's accounts</b> unless specified. This approach helps focus audience attention on the most crucial promotional links."
      }),
      t('config.integratedVideo.description.content4', {
        defaultValue:
          'Except for the legally required sponsorship disclosure in the description or caption, do not include any additional language or indications (e.g., "#ad" or "advertisement") that explicitly label the content as an ad.'
      })
    ],
    img: '/y-des-tag.png'
  },
  // {
  //   title: '',
  //   content: [
  //     'Avoid mentioning "paid partnership", "ad" or similar terms in the description.'
  //   ],
  //   img: '/y-des-avoid.png'
  // },
  {
    title: t('config.integratedVideo.musicAndEffects.title', {
      defaultValue: 'Music and effects'
    }),
    content: [
      t('config.integratedVideo.musicAndEffects.content', {
        defaultValue:
          'Check for copyright restrictions in your background music, sound effects, and clips.'
      })
    ],
    img: ''
  }
];

export const tTRequiredContents: {
  title: string;
  content: any[];
  img: string;
}[] = [
  {
    title: t('config.ttRequired.contentPermanence.title', {
      defaultValue: 'Content permanence requirement'
    }),
    content: [
      t('config.ttRequired.contentPermanence.content', {
        defaultValue:
          'The published content must remain permanently visible on your account. Content removal is not permitted under this collaboration agreement. This includes deleting, archiving, or making the post private.'
      })
    ],
    img: ''
  },
  {
    title: t('config.ttRequired.contentRestrictions.title', {
      defaultValue: 'Content restrictions'
    }),
    content: [
      t('config.ttRequired.contentRestrictions.content', {
        defaultValue:
          'We recommend avoiding political commentary, explicit sexual content, graphic violence, sensitive social issues, or misleading information in recent content, as these can negatively impact all brand collaborations.'
      })
    ],
    img: ''
  },
  {
    title: t('config.ttRequired.videoContent.title', {
      defaultValue: 'Video content'
    }),
    content: [
      t('config.ttRequired.videoContent.content', {
        defaultValue:
          'Once your application is approved, please select and closely imitate one of the "Hit Video Ideas" provided by Aha Studio. This step must be completed before initiating the video production process.'
      })
    ],
    img: '/head-studio.png'
  },
  {
    title: t('config.ttRequired.videoLength.title', {
      defaultValue: 'Video length'
    }),
    content: [
      t('config.ttRequired.videoLength.content', {
        defaultValue:
          'Keep video length between <b>20 seconds to 1 minute</b>, optimized for quick consumption and high engagement.'
      })
    ],
    img: '/20s.png'
  },
  {
    title: t('config.ttRequired.endingCta.title', {
      defaultValue: 'Ending CTA'
    }),
    content: [
      t('config.ttRequired.endingCta.content', {
        defaultValue:
          'Prompt viewers in speech and with caption <b>at the end of the video</b>, saying, "Tap the link in bio for more info!" and "Use the on-screen code {coupon code} for exclusive offers." if coupon code is provided'
      })
    ],
    img: '/tt-ending-cta.png'
  },
  {
    title: t('config.ttRequired.caption.title', {
      defaultValue: 'Caption'
    }),
    content: [
      t('config.ttRequired.caption.content', {
        defaultValue:
          'Use a concise and engaging caption with <b>a strong call-to-action</b>. Example: "Check the link in bio now!"'
      })
    ],
    img: '/tt-caption.png'
  },
  {
    title: '',
    content: [
      t('config.ttRequired.hashtags.content', {
        defaultValue:
          '<b>Include trending hashtags</b> that are relevant to the content to increase discoverability. Please check keywords from Aha Studio for reference.'
      })
    ],
    img: '/tt-caption-trending.png'
  },
  {
    title: '',
    content: [
      t('config.ttRequired.adDisclosure.content', {
        defaultValue:
          'Do not include any additional language or indications (e.g., "#ad" or "advertisement") in the caption that explicitly labels the content as an ad.'
      })
    ],
    img: '/tt-caption-avoid.png'
  },
  {
    title: t('config.ttRequired.linkInBio.title', {
      defaultValue: 'Link in Bio'
    }),
    content: [
      t('config.ttRequired.linkInBio.content1', {
        defaultValue:
          "The link should be placed <b>at the top of bio for at least 10 days</b>. If you're using Linktree, it is preferred to position the link directly above the Linktree in bio. Alternatively, it can be added as the first link within Linktree."
      }),
      <RequirementPromotionalText />
    ],
    img: '/tt-link-in-bio.png'
  },
  {
    title: t('config.ttRequired.musicAndAudio.title', {
      defaultValue: 'Music and audio'
    }),
    content: [
      t('config.ttRequired.musicAndAudio.content1', {
        defaultValue:
          "Use popular tracks from TikTok's music library or original sounds that are trending to enhance viewer retention."
      }),
      t('config.ttRequired.musicAndAudio.content2', {
        defaultValue:
          'Ensure any music or sound effects used are cleared for commercial use to avoid copyright issues.'
      })
    ],
    img: ''
  },
  {
    title: t('config.ttRequired.adsAuthorizationCode.title', {
      defaultValue: 'Ads authorization code'
    }),
    content: [
      t('config.ttRequired.adsAuthorizationCode.content', {
        defaultValue:
          'Upload ads authorization code for your content when submitting the final link.'
      })
    ],
    img: ''
  }
];

export const InstagramRequiredContents: {
  title: string;
  content: any[];
  img: string;
}[] = [
  {
    title: t('config.instagramRequired.contentPermanence.title', {
      defaultValue: 'Content permanence requirement'
    }),
    content: [
      t('config.instagramRequired.contentPermanence.content', {
        defaultValue:
          'The published content must remain permanently visible on your account. Content removal is not permitted under this collaboration agreement. This includes deleting, archiving, or making the post private.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramRequired.contentRestrictions.title', {
      defaultValue: 'Content restrictions'
    }),
    content: [
      t('config.instagramRequired.contentRestrictions.content', {
        defaultValue:
          'We recommend avoiding political commentary, explicit sexual content, graphic violence, sensitive social issues, or misleading information in recent content, as these can negatively impact all brand collaborations.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramRequired.videoContent.title', {
      defaultValue: 'Video content'
    }),
    content: [
      t('config.instagramRequired.videoContent.content', {
        defaultValue:
          'Once your application is approved, please select and closely imitate one of the "Hit Video Ideas" provided by Aha Studio. This step must be completed before initiating the video production process.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramRequired.videoLength.title', {
      defaultValue: 'Video length'
    }),
    content: [
      t('config.instagramRequired.videoLength.content', {
        defaultValue:
          'Ensure the Reel is between 15-30 seconds for optimal engagement.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramRequired.endingCta.title', {
      defaultValue: 'Ending CTA'
    }),
    content: [
      t('config.instagramRequired.endingCta.content1', {
        defaultValue:
          'Clearly state, "Swipe up for more info!" or "Check the link in bio!" depending on the features available.'
      }),
      t('config.instagramRequired.endingCta.content2', {
        defaultValue:
          'Display the on-screen coupon code for exclusive offers, if provided.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramRequired.linkInBio.title', {
      defaultValue: 'Link in Bio'
    }),
    content: [
      t('config.instagramRequired.linkInBio.content1', {
        defaultValue:
          "The link should be placed <b>at the top of bio for at least 10 days</b>. If you're using Linktree, it is preferred to position the link directly above the Linktree in bio. Alternatively, it can be added as the first link within Linktree."
      }),
      <RequirementPromotionalText />
    ],
    img: ''
  },
  {
    title: t('config.instagramRequired.caption.title', {
      defaultValue: 'Caption'
    }),
    content: [
      t('config.instagramRequired.caption.content1', {
        defaultValue: 'Begin with a strong Call-to-Action in the caption.'
      }),
      t('config.instagramRequired.caption.content2', {
        defaultValue: 'Example: "Visit the link in bio now!"'
      }),
      t('config.instagramRequired.caption.content3', {
        defaultValue: 'Mention any relevant hashtags.'
      }),
      t('config.instagramRequired.caption.content4', {
        defaultValue: '@mentions only if required.'
      }),
      t('config.instagramRequired.caption.content5', {
        defaultValue:
          'Do not mention it as a paid partnership in the caption unless required by legal guidelines.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramRequired.musicAndEffects.title', {
      defaultValue: 'Music and effects'
    }),
    content: [
      t('config.instagramRequired.musicAndEffects.content', {
        defaultValue:
          "Utilize copyright-free music or Instagram's provided library to avoid copyright infringement."
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramRequired.adsAuthorizationCode.title', {
      defaultValue: 'Ads authorization code'
    }),
    content: [
      t('config.instagramRequired.adsAuthorizationCode.content', {
        defaultValue:
          'Upload ads authorization code for your content when submitting the final link.'
      })
    ],
    img: ''
  }
];

export const InstagramPostRequiredContents: {
  title: string;
  content: any[];
  img: string;
}[] = [
  {
    title: t('config.instagramPostRequired.contentPermanence.title', {
      defaultValue: 'Content permanence requirement'
    }),
    content: [
      t('config.instagramPostRequired.contentPermanence.content', {
        defaultValue:
          'The published content must remain permanently visible on your account. Content removal is not permitted under this collaboration agreement. This includes deleting, archiving, or making the post private.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramPostRequired.contentRestrictions.title', {
      defaultValue: 'Content restrictions'
    }),
    content: [
      t('config.instagramPostRequired.contentRestrictions.content', {
        defaultValue:
          'We recommend avoiding political commentary, explicit sexual content, graphic violence, sensitive social issues, or misleading information in recent content, as these can negatively impact all brand collaborations.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramPostRequired.imageContent.title', {
      defaultValue: 'Image content'
    }),
    content: [
      t('config.instagramPostRequired.imageContent.content1', {
        defaultValue:
          'Once your application is approved, please select and closely imitate one of the "Hit Content Ideas" provided by Aha Studio. This step must be completed before initiating the content production process.'
      }),
      t('config.instagramPostRequired.imageContent.content2', {
        defaultValue:
          'Include 3-5 images in the carousel to effectively showcase the product or'
      }),
      t('config.instagramPostRequired.imageContent.content3', {
        defaultValue:
          'Use high-resolution images, professionally captured to emphasize product details.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramPostRequired.linkInBio.title', {
      defaultValue: 'Link in Bio'
    }),
    content: [
      t('config.instagramPostRequired.linkInBio.content1', {
        defaultValue:
          "The link should be placed <b>at the top of bio for at least 10 days</b>. If you're using Linktree, it is preferred to position the link directly above the Linktree in bio. Alternatively, it can be added as the first link within Linktree."
      }),
      <RequirementPromotionalText />
    ],
    img: ''
  },
  {
    title: t('config.instagramPostRequired.captions.title', {
      defaultValue: 'Captions'
    }),
    content: [
      t('config.instagramPostRequired.captions.content1', {
        defaultValue:
          'Begin with <b>a strong Call-to-Action</b> in the caption.'
      }),
      t('config.instagramPostRequired.captions.content2', {
        defaultValue: 'Example: "Visit the link in bio now!"'
      }),
      t('config.instagramPostRequired.captions.content3', {
        defaultValue: 'Mention any relevant hashtags.'
      }),
      t('config.instagramPostRequired.captions.content4', {
        defaultValue: '@mentions only if required.'
      }),
      t('config.instagramPostRequired.captions.content5', {
        defaultValue:
          'Do not include any additional language or indications (e.g., "#ad" or "advertisement") in the caption that explicitly labels the content as an ad.'
      })
    ],
    img: ''
  },
  {
    title: t('config.instagramPostRequired.adsAuthorizationCode.title', {
      defaultValue: 'Ads authorization code'
    }),
    content: [
      t('config.instagramPostRequired.adsAuthorizationCode.content', {
        defaultValue:
          'Upload ads authorization code for your content when submitting the final link.'
      })
    ],
    img: ''
  }
];

export const TwitterRequiredContents: {
  title: string;
  content: any[];
  img: string;
}[] = [
  {
    title: t('config.twitterRequired.contentPermanence.title', {
      defaultValue: 'Content permanence requirement'
    }),
    content: [
      t('config.twitterRequired.contentPermanence.content', {
        defaultValue:
          'The published content must remain permanently visible on your account. Content removal is not permitted under this collaboration agreement. This includes deleting, archiving, or making the post private.'
      })
    ],
    img: ''
  },
  {
    title: t('config.twitterRequired.contentRestrictions.title', {
      defaultValue: 'Content restrictions'
    }),
    content: [
      t('config.twitterRequired.contentRestrictions.content', {
        defaultValue:
          'We recommend avoiding political commentary, explicit sexual content, graphic violence, sensitive social issues, or misleading information in recent content, as these can negatively impact all brand collaborations.'
      })
    ],
    img: ''
  },
  {
    title: t('config.twitterRequired.videoContent.title', {
      defaultValue: 'Video content'
    }),
    content: [
      t('config.twitterRequired.videoContent.content1', {
        defaultValue:
          'Once your application is approved, please select and closely imitate one of the "Hit Video Ideas" provided by Aha Studio. This step must be completed before initiating the video production process.'
      }),
      t('config.twitterRequired.videoContent.content2', {
        defaultValue: 'Please add subtitles to the video.'
      })
    ],
    img: '/head-studio.png'
  },
  {
    title: t('config.twitterRequired.videoLength.title', {
      defaultValue: 'Video length'
    }),
    content: [
      t('config.twitterRequired.videoLength.content', {
        defaultValue: 'Videos should be between 1-2 minutes long.'
      })
    ],
    img: ''
  },
  {
    title: t('config.twitterRequired.endingCta.title', {
      defaultValue: 'Ending CTA'
    }),
    content: [
      t('config.twitterRequired.endingCta.content', {
        defaultValue:
          'Integrate a clear verbal or text-based CTA within the video, such as "Visit the link in our tweet for more info."'
      })
    ],
    img: ''
  },
  {
    title: t('config.twitterRequired.imageBasedContent.title', {
      defaultValue: 'Image-Based content'
    }),
    content: [
      t('config.twitterRequired.imageBasedContent.content1', {
        defaultValue:
          'Attach informative captions to each image, focusing on distinct features or benefits.'
      }),
      t('config.twitterRequired.imageBasedContent.content2', {
        defaultValue:
          'Use high-resolution images, professionally captured to emphasize product details.'
      })
    ],
    img: ''
  },
  {
    title: t('config.twitterRequired.tweet.title', { defaultValue: 'Tweet' }),
    content: [
      t('config.twitterRequired.tweet.content1', {
        defaultValue:
          'Post with a strong CTA in the caption, like: "Check out more: {link}"'
      }),
      <RequirementPromotionalText />,
      t('config.twitterRequired.tweet.content3', {
        defaultValue: 'Use relevant hashtags to increase visibility.'
      }),
      t('config.twitterRequired.tweet.content4', {
        defaultValue:
          'Avoid tagging the brand unless it is part of a collaboration effort.'
      }),
      t('config.twitterRequired.tweet.content5', {
        defaultValue:
          'Do not include any additional language or indications (e.g., "#ad" or "advertisement") in the caption that explicitly labels the content as an ad.'
      })
    ],
    img: ''
  },
  {
    title: t('config.twitterRequired.musicAndSound.title', {
      defaultValue: 'Music and sound'
    }),
    content: [
      t('config.twitterRequired.musicAndSound.content1', {
        defaultValue: 'Voiceover is required in the video.'
      }),
      t('config.twitterRequired.musicAndSound.content2', {
        defaultValue:
          'Ensure all background music and sound effects are cleared for use to avoid copyright issues.'
      })
    ],
    img: ''
  }
];

export const LinkedInImageRequiredContents: {
  title: string;
  content: any[];
  img: string;
}[] = [
  {
    title: t('config.linkedinRequired.contentPermanence.title', {
      defaultValue: 'Content permanence requirement'
    }),
    content: [
      t('config.linkedinRequired.contentPermanence.content', {
        defaultValue:
          'The published content must remain permanently visible on your account. Content removal is not permitted under this collaboration agreement. This includes deleting, archiving, or making the post private.'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.contentRestrictions.title', {
      defaultValue: 'Content restrictions'
    }),
    content: [
      t('config.linkedinRequired.contentRestrictions.content', {
        defaultValue:
          'We recommend avoiding political commentary, explicit sexual content, graphic violence, sensitive social issues, or misleading information in recent content, as these can negatively impact all brand collaborations.'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.imageBasedContent.title', {
      defaultValue: 'Image-Based content'
    }),
    content: [
      t('config.linkedinRequired.imageBasedContent.content1', {
        defaultValue:
          'Attach informative captions to each image, focusing on distinct features or benefits.'
      }),
      t('config.linkedinRequired.imageBasedContent.content2', {
        defaultValue:
          'Use high-resolution images, professionally captured to emphasize product details.'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.post.title', { defaultValue: 'Post' }),
    content: [
      t('config.linkedinRequired.post.content1', {
        defaultValue:
          'Post with a strong CTA in the caption, like: "Check out more: {link}"'
      }),
      t('config.linkedinRequired.post.content6', {
        defaultValue: 'Must put the promotional link in the caption.'
      }),
      <RequirementPromotionalText />,
      t('config.linkedinRequired.post.content3', {
        defaultValue: 'Use relevant hashtags to increase visibility.'
      }),
      t('config.linkedinRequired.post.content4', {
        defaultValue:
          'Avoid tagging the brand unless it is part of a brand requirement.'
      }),
      t('config.linkedinRequired.post.content5', {
        defaultValue:
          'Do not include any additional language or indications (e.g., "#ad" or "advertisement") in the caption that explicitly labels the content as an ad.'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.musicAndSound.title', {
      defaultValue: 'Music and sound'
    }),
    content: [
      t('config.linkedinRequired.musicAndSound.content1', {
        defaultValue: 'Voiceover is required in the video.'
      }),
      t('config.linkedinRequired.musicAndSound.content2', {
        defaultValue:
          'Ensure all background music and sound effects are cleared for use to avoid copyright issues.'
      })
    ],
    img: ''
  }
];

export const LinkedInVideoRequiredContents: {
  title: string;
  content: any[];
  img: string;
}[] = [
  {
    title: t('config.linkedinRequired.contentPermanence.title', {
      defaultValue: 'Content permanence requirement'
    }),
    content: [
      t('config.linkedinRequired.contentPermanence.content', {
        defaultValue:
          'The published content must remain permanently visible on your account. Content removal is not permitted under this collaboration agreement. This includes deleting, archiving, or making the post private.'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.contentRestrictions.title', {
      defaultValue: 'Content restrictions'
    }),
    content: [
      t('config.linkedinRequired.contentRestrictions.content', {
        defaultValue:
          'We recommend avoiding political commentary, explicit sexual content, graphic violence, sensitive social issues, or misleading information in recent content, as these can negatively impact all brand collaborations.'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.videoContent.title', {
      defaultValue: 'Video content'
    }),
    content: [
      t('config.linkedinRequired.videoContent.content1', {
        defaultValue:
          'Once your application is approved, please select and closely imitate one of the "Hit Video Ideas" provided by Aha Studio. This step must be completed before initiating the video production process.'
      }),
      t('config.linkedinRequired.videoContent.content2', {
        defaultValue: 'Please add subtitles to the video.'
      })
    ],
    img: '/head-studio.png'
  },
  {
    title: t('config.linkedinRequired.videoLength.title', {
      defaultValue: 'Video length'
    }),
    content: [
      t('config.linkedinRequired.videoLength.content', {
        defaultValue: 'Videos should be between 1-2 minutes long.'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.endingCta.title', {
      defaultValue: 'Ending CTA'
    }),
    content: [
      t('config.linkedinRequired.endingCta.content', {
        defaultValue:
          'Integrate a clear verbal or text-based CTA within the video, such as "Visit the link in my post for more info."'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.post.title', { defaultValue: 'Post' }),
    content: [
      t('config.linkedinRequired.post.content1', {
        defaultValue:
          'Post with a strong CTA in the caption, like: "Check out more: {link}"'
      }),
      t('config.linkedinRequired.post.content6', {
        defaultValue: 'Must put the promotional link in the caption.'
      }),
      <RequirementPromotionalText />,
      t('config.linkedinRequired.post.content3', {
        defaultValue: 'Use relevant hashtags to increase visibility.'
      }),
      t('config.linkedinRequired.post.content4', {
        defaultValue:
          'Avoid tagging the brand unless it is part of a brand requirement.'
      }),
      t('config.linkedinRequired.post.content5', {
        defaultValue:
          'Do not include any additional language or indications (e.g., "#ad" or "advertisement") in the caption that explicitly labels the content as an ad.'
      })
    ],
    img: ''
  },
  {
    title: t('config.linkedinRequired.musicAndSound.title', {
      defaultValue: 'Music and sound'
    }),
    content: [
      t('config.linkedinRequired.musicAndSound.content1', {
        defaultValue: 'Voiceover is required in the video.'
      }),
      t('config.linkedinRequired.musicAndSound.content2', {
        defaultValue:
          'Ensure all background music and sound effects are cleared for use to avoid copyright issues.'
      })
    ],
    img: ''
  }
];

export enum ProductType {
  WEB_APP = 'web app',
  MOBILE_APP = 'mobile app',
  DESKTOP_APP = 'desktop app',
  BROWSER_EXTENSION = 'browser extension',
  PHYSICAL_PRODUCT = 'physical product'
}

export enum ProductPhysicalSelectEnum {
  ship = 'Shipping',
  video = 'ShareVideo'
}

// 广告主当前这个活动的状态
export enum activityStatus {
  Draft = 'Draft',
  Predicting = 'Predicting',
  UnderReview = 'Under_review',
  Active = 'Active',
  Paused = 'Paused', // 扣费失败暂停
  TempPaused = 'Temp_paused', // 临时暂停
  Cancelled = 'Cancelled',
  Ended = 'Ended'
}
